export function createSupportTimelineClient(transport) {
    return {
        /**
         * POST /internal/v1/tenants/{tenantId}/support-timeline/events
         *
         * Requires scope: support-timeline:project
         */
        projectSupportTimelineEvent(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-timeline/events`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/support-cases/{caseId}/timeline
         *
         * Requires scope: support-timeline:read
         */
        listSupportTimeline(tenantId, caseId, cursor, limit, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(caseId)}/timeline`,
                query: { cursor: cursor, limit: limit },
                options,
            });
        },
        /**
         * GET /v1/tenants/{tenantId}/support-cases/{caseId}/timeline
         *
         * Requires scope: support-timeline:read
         */
        getSupportCaseTimeline(tenantId, caseId, cursor, limit, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(caseId)}/timeline`,
                query: { cursor: cursor, limit: limit },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/support-cases/{caseId}/timeline/rebuild
         *
         * Requires scope: support-timeline:rebuild
         */
        rebuildSupportTimeline(tenantId, caseId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(caseId)}/timeline/rebuild`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=support-timeline.js.map